import * as React from 'react';
import type { CSSProperties } from 'react';
import { cn } from '../../lib/cn';

export interface SkeletonProps {
  variant?: 'text' | 'circle' | 'rect';
  width?: string | number;
  height?: string | number;
  className?: string;
  /** Extra inline styles — used by compound components for staggered animation-delay */
  style?: CSSProperties;
}

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  function Skeleton(
    { variant = 'rect', width, height, className, style },
    ref,
  ) {
    return (
      <div
        ref={ref}
        className={cn(
          'nv-skel',
          variant === 'text' && 'nv-skel-text',
          variant === 'circle' && 'nv-skel-circle',
          className,
        )}
        style={{ width, height, ...style }}
        aria-hidden="true"
      />
    );
  },
);
